import { render } from "./WellnessJourneyPromo.vue?vue&type=template&id=78f4e52f&scoped=true"
import script from "./WellnessJourneyPromo.vue?vue&type=script&lang=js"
export * from "./WellnessJourneyPromo.vue?vue&type=script&lang=js"

import "./WellnessJourneyPromo.vue?vue&type=style&index=0&id=78f4e52f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78f4e52f"]])

export default __exports__